<template>
  <div class="order-item">
    <order-item-header :order-item="orderItem"></order-item-header>

    <order-item-applicants
      :applicant-list="orderItem.applicant_set"
    ></order-item-applicants>

    <order-item-btn-list :order-item="orderItem"></order-item-btn-list>
  </div>
</template>

<script>
import orderItemHeader from './components/order-item-header';
import orderItemApplicants from './components/order-item-applicants';
import orderItemBtnList from './components/order-item-btn-list';

export default {
  components: {
    orderItemHeader,
    orderItemApplicants,
    orderItemBtnList,
  },
  props: {
    orderItem: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped lang="less">
.order-item {
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 12px;
  background-color: white;
  padding-bottom: 16px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>
